// Persönliche Default-Werte für Project-View und „Meine Aufgaben"-Filter.
// Lokal in localStorage gespeichert (kein Backend-Roundtrip nötig, weil es
// rein UX-Convenience ist und beim Login per User-Preferences-Sync später
// auf den Server gemerged werden kann).

export type DefaultProjectView = "table" | "timeline" | "kanban" | "calendar";
export type DefaultTaskFilter = "all" | "this-week" | "overdue";

const VIEW_KEY = "juuplan:default-view";
const FILTER_KEY = "juuplan:default-filter";

export function loadDefaultView(): DefaultProjectView {
  if (typeof localStorage === "undefined") return "table";
  const raw = localStorage.getItem(VIEW_KEY);
  if (raw === "timeline" || raw === "kanban" || raw === "calendar") return raw;
  return "table";
}
export function saveDefaultView(v: DefaultProjectView): void {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(VIEW_KEY, v);
}

export function loadDefaultFilter(): DefaultTaskFilter {
  if (typeof localStorage === "undefined") return "all";
  const raw = localStorage.getItem(FILTER_KEY);
  if (raw === "this-week" || raw === "overdue") return raw;
  return "all";
}
export function saveDefaultFilter(f: DefaultTaskFilter): void {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(FILTER_KEY, f);
}
